const logger = (store: any) => (next: any) => (action: any) => {
  console.group(action.type);
  const result = next(action);
  console.groupEnd();
  return result;
};

export default logger;
